module.exports = __webpack_public_path__ + "static/media/starred.ae48a464.svg";